<template>
  <div id="documents" class="sun">
    <div class="documents">
      <DocumentList :documents="documents"></DocumentList>
    </div>
    <button class="confirm"
            :class="{'active': isComplete}" :disabled="!isComplete"
            @click="next">
      서류제출 완료
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

// Apis
import userApi from '@/api/now/userApi'
import contractsApi from '@/api/now/contractsApi'

// Components
import DocumentList from './components/DocumentList'

export default {
  name: 'documents',
  components: {
    DocumentList
  },
  props: {},
  data: function () {
    return {
      isAgreedAll: false,
      documents: {
        identification: { title: '신분증사본', file: null },
        business_license: { title: '사업자등록증', file: null },
        bankbook: null,
        certificate_of_income_amount: { title: '소득금액증명원', file: null },
      },
      terms: [],
      agreements: [],
      collectionAccount: null
    }
  },
  computed: {
    ...mapGetters('auth', {
      user: 'getProfile'
    }),
    isCompleteDocuments() { // 서류 완료 여부
      return this.user.kyc.id_card_verification_is_done && this.documents.business_license.file && this.documents.bankbook.file && this.documents.certificate_of_income_amount.file
    },
    isComplete() { // 전체 완료 여부
      return this.isCompleteDocuments
    }
  },
  async created() {
    this.$store.commit('ui/headerTitle', '서류 제출')
    await this.getCollectionAccount()
    await this.getDocuments()
  },
  destroyed() {},
  methods: {
    async getCollectionAccount() {
      let { data } = await userApi.getCollectionAccount()
      this.collectionAccount = data
      if (this.collectionAccount.bank === '39') {
        this.documents.bankbook = { title: 'BNK 경남은행 통장사본', description: 'BNK경남은행 모바일뱅킹 어플에서 통장사본 캡쳐 가능', file: null }
      } else if (this.collectionAccount.bank === '50') {
        this.documents.bankbook = { title: '웰컴디지컬뱅크 통장사본', description: '웰컴디지털뱅크 웰뱅 어플에서 통장사본 캡쳐 가능', file: null }
      } else {
        this.documents.bankbook = { title: '통장사본', description: '어플에서 통장사본 캡쳐 가능', file: null }
      }
    },
    async getDocuments() {
      let data = await contractsApi.getDocuments()
      this.documents.business_license.file = data.data.business_license
      this.documents.bankbook.file = data.data.bankbook
      this.documents.certificate_of_income_amount.file = data.data.certificate_of_income_amount
    },
    next() {
      this.$router.push({ name: 'agreements' })
    }
  },
}
</script>

<style lang="scss" scoped>

  #documents {
    height: calc(100vh - 60px);
    .documents {
      width: 100%;
      height: calc(100% - 68px);
      overflow: auto;
    }

    .confirm {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      width: 100%;
      height: 68px;
      font-size: 22px;
      color: #727d8c;
      font-weight: bold;
      background-color: #e3ecf6;
      z-index: 1000;

      &.active {
        color: white;
        background-color: #1baaf1;
      }
    }
  }
</style>
